// VicTech #710:分页标题前缀 (N)。用 MutationObserver 盯 <title>,别的程式改了标题也会补回前缀。
const PREFIX_RE = /^\(\d+\)\s/;

export const stripPrefix = title => (title || '').replace(PREFIX_RE, '');

export const formatTitle = (title, count) => {
  const base = stripPrefix(title);
  return count > 0 ? `(${count}) ${base}` : base;
};

export class TitleBadge {
  constructor(doc = document) {
    this.doc = doc;
    this.count = 0;
    this.observer = null;
  }

  titleNode() {
    let node = this.doc.querySelector('head > title');
    if (!node) {
      node = this.doc.createElement('title');
      this.doc.head.appendChild(node);
    }
    return node;
  }

  render() {
    const next = formatTitle(this.doc.title, this.count);
    if (this.doc.title !== next) this.doc.title = next;
  }

  start() {
    if (this.observer || typeof MutationObserver === 'undefined') return;
    this.observer = new MutationObserver(() => this.render());
    this.observer.observe(this.titleNode(), {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  set(count) {
    this.count = count;
    this.render();
  }

  stop() {
    if (this.observer) this.observer.disconnect();
    this.observer = null;
    this.count = 0;
    this.render();
  }
}
